import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type UseStarterDashboardTabExperiment = ModelHookResult<
	undefined,
	{
		trackClick: (event_name: string, tab: string) => void;
	}
>;

export function useDashboardTabs(): UseStarterDashboardTabExperiment {
	const track = useTracking();

	const trackClick = useCallback(
		(eventName: string, tab: string) => {
			void track(eventName, {
				context: tab,
			});
		},
		[track],
	);

	return {
		actions: {
			trackClick,
		},
	};
}
